import React from 'react';
import ngDateFilter from '../ngDateFilter.js';
import './Comments.css';

export class Comment extends React.PureComponent {
  _delete = () => {
    const {comment, onDelete} = this.props;
    onDelete(comment);
  };

  _fetchContextActions = () => {
    const {comment, onFetchContextActions} = this.props;
    onFetchContextActions(comment._links.context_actions.href, comment._links.self.href);
  };

  render() {
    const {comment} = this.props;
    return (
      <div className="Comment" key={comment.id}>
        <CommentDropdown comment={comment} contextActions={this.props.contextActions} onDelete={this._delete} onFetch={this._fetchContextActions} />
        <div className="CommentForm clearfix">
          <div className="CommentAuthorAvatar">
            <img src={comment._embedded.author._links.profile_picture.href} />
          </div>
          <div className="CommentText">
            <a href={comment._embedded.author._links.self.href}>
              {comment._embedded.author.display_name}
            </a>
            {' '}<span className="CommentTime">{ngDateFilter(comment.created_at, 'MMM d, y h:mm a')}</span>
            <div dangerouslySetInnerHTML={{__html: comment.content_html}}></div>
          </div>
        </div>
      </div>
    );
  }
}

class CommentDropdown extends React.PureComponent {
  render() {
    const {comment, contextActions} = this.props;
    return (
      <div className="CommentDropdown dropdown">
        <a className="CommentDropdown-toggle" data-toggle="dropdown" onClick={this.props.onFetch}>
          <i className="fa fa-angle-down txt-middle" style={{lineHeight: 'inherit'}}></i>
        </a>
        <ul className="dropdown-menu">
          {
            !contextActions ? (
              <li className="loading-gif"></li>
            ): null
          }
          {
            contextActions ? (
              <li>
                <a data-user-voice-report-abuse={comment._links.self.href}><span className="fa fa-flag"></span> Report Abuse</a>
              </li>
            ): null
          }
          {
            contextActions && contextActions.delete ? (
              <li>
                <a onClick={this.props.onDelete}>
                  <i className="fa fa-times"></i> Delete
                </a>
              </li>
            ): null
          }
        </ul>
      </div>
    );
  }
}

export function CommentForm (props) {
  const disabled = props.submitting || props.smsVerificationRequired;
  return (
    <div className="Comment">
      <form className="CommentForm clearfix" onSubmit={props.onSubmit}>
        <div className="input-group">
          <input type="text" className="form-control" placeholder="Enter a comment" value={props.value}  disabled={disabled} onChange={props.onChange} />
          <span className="input-group-btn">
            <button className="btn btn-default" disabled={disabled} type="submit">Post</button>
          </span>
        </div>
        {
          props.smsVerificationRequired ? (
            <div className="help-block text-danger">
              You are required to <a href={'/verify_cell_phone?return_to=' + window.location.pathname}>verify your cell phone number</a> before you are able to make a comment.
            </div>
          ): null
        }
      </form>
    </div>
  );
}
